export default __webpack_public_path__ + "static/media/etown_logo.b8682d4d.png";